export const MUNICIPALITY_IBGE_STORAGE_KEY = "codigo-ibge-municipio";
export const MUNICIPALITY_DEPARTMENT_STORAGE_KEY = "cod-departamento-municipio";
export const CATALOG_SLUG_STORAGE_KEY = "slug-carta-servico";

export type MunicipalityDetailStorageContext = {
  codIbgeMunicipio?: string;
  codDepartamentoMunicipio?: string;
  catalogSlug?: string;
};

function isBrowserStorageAvailable(): boolean {
  return (
    typeof globalThis.window !== "undefined" &&
    typeof globalThis.window.localStorage !== "undefined"
  );
}

export function saveMunicipalityDetailContext({
  codIbgeMunicipio,
  codDepartamentoMunicipio,
  catalogSlug,
}: {
  codIbgeMunicipio: number | string;
  codDepartamentoMunicipio: string;
  catalogSlug: string;
}): void {
  if (!isBrowserStorageAvailable()) {
    return;
  }

  globalThis.window.localStorage.setItem(
    MUNICIPALITY_IBGE_STORAGE_KEY,
    String(codIbgeMunicipio)
  );
  globalThis.window.localStorage.setItem(
    MUNICIPALITY_DEPARTMENT_STORAGE_KEY,
    codDepartamentoMunicipio
  );
  globalThis.window.localStorage.setItem(CATALOG_SLUG_STORAGE_KEY, catalogSlug);
}

export function getMunicipalityDetailContext(): MunicipalityDetailStorageContext {
  if (!isBrowserStorageAvailable()) {
    return {};
  }

  const codIbgeMunicipio = globalThis.window.localStorage.getItem(
    MUNICIPALITY_IBGE_STORAGE_KEY
  );
  const codDepartamentoMunicipio = globalThis.window.localStorage.getItem(
    MUNICIPALITY_DEPARTMENT_STORAGE_KEY
  );
  const catalogSlug = globalThis.window.localStorage.getItem(
    CATALOG_SLUG_STORAGE_KEY
  );

  return {
    ...(codIbgeMunicipio ? { codIbgeMunicipio } : {}),
    ...(codDepartamentoMunicipio ? { codDepartamentoMunicipio } : {}),
    ...(catalogSlug ? { catalogSlug } : {}),
  };
}

export function clearMunicipalityDetailContext(): void {
  if (!isBrowserStorageAvailable()) {
    return;
  }

  globalThis.window.localStorage.removeItem(MUNICIPALITY_IBGE_STORAGE_KEY);
  globalThis.window.localStorage.removeItem(
    MUNICIPALITY_DEPARTMENT_STORAGE_KEY
  );
  globalThis.window.localStorage.removeItem(CATALOG_SLUG_STORAGE_KEY);
}
